module.exports = __webpack_public_path__ + "img/blue.5bcd55d4.png";